import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import CatalogService from "../service/catalogService";
import {useEffect, useState} from "react";
import {toast} from "sonner";

export function useCatalogs(id) {

    const queryClient = useQueryClient()

    const {data: catalogsData, isPending} = useQuery({
        queryKey: ["catalogs"],
        queryFn: () => CatalogService.getAll()
    });

    const {data: catalogsSubData} = useQuery({
        queryKey: ["subCatalogs"],
        queryFn: () => CatalogService.getAllSub()
    });

    const {mutate: update} = useMutation({
        mutationKey: ["catalogsUpdate"],
        mutationFn: async (data) => {
            id === -1 ? await CatalogService.updateCategory(data) : await CatalogService.updateSubCategory(data)
        },
        onSuccess: () => {
            toast.success("Каталог обновлен")
            queryClient.invalidateQueries({queryKey: ['catalogs']})
        },
    })

    const {mutate: create} = useMutation({
        mutationKey: ["createCatalog"],
        mutationFn: async (data) => {
            data.get('categoryId') === "-1" ?
                await CatalogService.create(data)
                : await CatalogService.createSub(data)
        },
        onSuccess: () => {
            toast.success("Каталог успешно создан")
            queryClient.invalidateQueries({queryKey: ['catalogs']})
        },
    })

    const {mutate: deleteCatalogs} = useMutation({
        mutationFn: async ({id: idDeleteItem, isCategory}) => await CatalogService.delete(idDeleteItem, isCategory),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['catalogs']})
            toast.success("Каталог удален")
        },
        onError: () => toast.error("Не удалось удалить каталог")
    })

    const {mutate: updateOrder} = useMutation({
        mutationKey: ["updateOrder"],
        mutationFn: async ({orders, parentId}) => {
            await CatalogService.updateOrder({orders, parentId})
        },
        onSuccess: () => {
            toast.success("Каталог перемещен")
            queryClient.invalidateQueries({queryKey: ['catalogs']})
        }
    })

    const [catalogs, setCatalogs] = useState(catalogsData?.data);
    const [subCatalogs, setSubCatalogs] = useState(catalogsSubData?.data);

    useEffect(() => {
        const data = catalogsData?.data
        setCatalogs(data?.find(item => item.id === id)?.subdirectories || data);
    }, [catalogsData?.data, id])

    useEffect(() => {
        setSubCatalogs(catalogsSubData?.data)
    }, [catalogsSubData?.data])

    return {catalogs, update, create, deleteCatalogs, catalogsSubData: subCatalogs, updateOrder};
}
